import PropTypes from "prop-types"
import { Box, Flex, Text } from "@chakra-ui/react"

export default function CompanyAbout({ title, name }) {
  return (
    <Box
      w="full"

      py={2}
    >
      <Flex
        direction={{ base: "column", sm: "row" }}
        justify={{ base: "flex-start", sm: "space-between" }}
        align={{ base: "flex-start", sm: "center" }}
        gap={{ base: 2, md: 4 }}
        px={2}
      >
        <Text
          color="gray.600"
          fontSize="15px"
          fontWeight="medium"
          textTransform="capitalize"
          flex={{ base: "none", sm: "1" }}
          minW={{ base: "auto", sm: "150px" }}
        >
          {title}
        </Text>
        <Text
          color="gray.900"
          fontSize="15px"
          fontWeight="normal"
          textAlign={{ base: "left", sm: "right" }}
          textTransform="capitalize"
          flex={{ base: "none", sm: "1" }}
          wordBreak="break-word"
          whiteSpace="pre-wrap"
        >
          {name || "--"}
        </Text>
      </Flex>
    </Box>
  )
}

// Define PropTypes
CompanyAbout.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  name: PropTypes.string.isRequired,
}